module.exports = __webpack_public_path__ + "img/part_16.0ead36d5.png";